// @ts-nocheck TODO remove me
import { includes, findKey, throttle } from 'lodash';
import * as cd from 'debug';

const debug = cd('app:services:tracking-manager');

export enum Target {
    MainbetAdd = 'mainbet_add',
    LivebetAdd = 'livebet_add',
    FooterbetAdd = 'footerbet_add',
    GamesContainerMarket = 'games_container_market',
    AcceptBet = 'accept_bet',
    NotacceptBet = 'notaccept_bet',
    OddsUpdates = 'odds_updates',
    DeleteAll = 'delete_all',
    Minimize = 'minimize',
    MakeBet = 'make_bet',
    TheaterModeVideoOpen = 'theatermode_video_open',
    TheaterModeVideoClose = 'theatermode_video_close',
    TheaterModeMatchOpen = 'theatermode_match_open',
    TheaterModeMatchClose = 'theatermode_match_close',
    $BetAdd = 'bet_add',
}

export enum Origin {
    Main = 'main',
    Live = 'live',
    Footer = 'footer',
}

class TrackingManager {
    public registerUserAction(target) {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }

        if (typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({ event: target });
            debug('update dataLayer', window.dataLayer);
        }
    }

    public markTarget(target: Target | null) {
        if (!target) return {};

        return { 'data-analytics-info': target };
    }

    public markOrigin(origin: Origin) {
        return { 'data-analytics-origin': origin };
    }

    private getEventPath(e): HTMLElement[] {
        const path = (e.composedPath && e.composedPath()) || e.path;
        const target = e.target;

        if (path != null) {
            return path.indexOf(window) < 0 ? path.concat(window) : path;
        }

        if (target === window) {
            return [window] as any[];
        }

        function getParents(node, memo) {
            memo = memo || [];
            const parentNode = node.parentNode;

            if (!parentNode) {
                return memo;
            } else {
                return getParents(parentNode, memo.concat(parentNode));
            }
        }

        return [target].concat(getParents(target, null), window);
    }

    private handleUserClick = (e: Event) => {
        debug('handle event', e);

        let originInfo = '';
        const ePath = this.getEventPath(e);

        ePath.reverse().forEach(element => {
            if (!element || !element.dataset) {
                return;
            }

            if (element.dataset.analyticsOrigin) {
                originInfo = element.dataset.analyticsOrigin;
            }

            const attribute = element.dataset.analyticsInfo;

            if (attribute) {
                const targetKey = findKey(Target, value => value === attribute);

                if (targetKey && targetKey.includes('$') && originInfo) {
                    this.registerUserAction(originInfo + attribute);
                } else if (includes(Target, attribute)) {
                    this.registerUserAction(attribute);
                }
            }
        });
    };

    private throttledUserClickHandler = throttle(this.handleUserClick, 300, {
        trailing: false,
    });

    public init() {
        document.addEventListener('mousedown', this.throttledUserClickHandler);
        document.addEventListener('touchstart', this.throttledUserClickHandler);
    }

    public cleanUp() {
        document.removeEventListener(
            'mousedown',
            this.throttledUserClickHandler
        );
        document.removeEventListener(
            'touchstart',
            this.throttledUserClickHandler
        );
    }
}

let trackingManagerInstance: TrackingManager | null = null;

function getTrackingManager() {
    if (!trackingManagerInstance) {
        trackingManagerInstance = new TrackingManager();
    }

    return trackingManagerInstance;
}

export { TrackingManager, getTrackingManager as tracker };
